export enum MetricsMenuOptions {
  DUPLICATE = "Duplicate",
  RENAME = "Rename",
}
